import { fork } from 'redux-saga/effects';

import { actions } from 'domain/item';
import { itemNavigator } from 'sagas/common';
import { editableFields } from './index';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Item', actions, editableFields }, args);
}
